import { render, staticRenderFns } from "./statistical-analysis-home.vue?vue&type=template&id=4d0fe537&"
import script from "./statistical-analysis-home.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-home.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-home.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports